import PublicNav from '../components/layout/PublicNav';
import PublicFooter from '../components/layout/PublicFooter';

const VALUES = [
  { icon: '🚀', title: 'Move fast', desc: 'We ship quickly and iterate based on real customer feedback.' },
  { icon: '🤝', title: 'Customer first', desc: 'Every decision is weighed against what actually helps the people we serve.' },
  { icon: '🔍', title: 'Radical transparency', desc: 'Clear pricing, clear communication — internally and with our users.' },
];

export default function Careers() {
  return (
    <div style={{ background: 'transparent', color: 'var(--text-1)', minHeight: '100vh', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column' }}>
      <PublicNav />

      <main style={{ flex: 1 }}>

      <section style={{ padding: '4.5rem 5% 3rem', textAlign: 'center' }}>
        <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#818CF8', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: '0.75rem' }}>Careers</div>
        <h1 style={{ fontSize: 'clamp(1.8rem,3.5vw,2.6rem)', fontWeight: 900, fontFamily: 'Space Grotesk, sans-serif', letterSpacing: '-0.02em', marginBottom: '1rem' }}>
          Help build the future of finance in Nigeria
        </h1>
        <p style={{ fontSize: '1rem', color: 'var(--text-2)', lineHeight: 1.75, maxWidth: 600, margin: '0 auto' }}>
          We're a small team building products that make financial services faster, fairer, and more accessible.
        </p>
      </section>

      <section style={{ padding: '0 5% 3.5rem' }}>
        <div style={{ maxWidth: 900, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1.25rem' }}>
          {VALUES.map(({ icon, title, desc }) => (
            <div key={title} style={{ padding: '1.5rem', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16 }}>
              <div style={{ fontSize: '1.6rem', marginBottom: '0.75rem' }}>{icon}</div>
              <div style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.4rem' }}>{title}</div>
              <div style={{ fontSize: '0.85rem', color: 'var(--text-2)', lineHeight: 1.6 }}>{desc}</div>
            </div>
          ))}
        </div>
      </section>

      <section style={{ padding: '0 5% 5rem', textAlign: 'center' }}>
        <div style={{ maxWidth: 560, margin: '0 auto', padding: '2rem', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16 }}>
          <h2 style={{ fontSize: '1.15rem', fontWeight: 700, marginBottom: '0.6rem' }}>No open roles right now</h2>
          <p style={{ fontSize: '0.88rem', color: 'var(--text-2)', lineHeight: 1.65, marginBottom: '1.25rem' }}>
            We're not actively hiring at the moment, but we're always interested in hearing from talented people. Reach out and tell us how you'd like to help.
          </p>
          <a href="mailto:careers@mypcredit.com" className="btn btn-primary">Email careers@mypcredit.com</a>
        </div>
      </section>

      </main>

      <PublicFooter />
    </div>
  );
}
